/**
 * Border width tokens.
 *
 * @module @smoothie-framework/ui-core/tokens
 */
export const borderWidths = Object.freeze({
    xs: '0.5px',
    sm: '1px',
    md: '2px',
    lg: '4px',
    xl: '8px',
});
const BORDER_WIDTH_TOKEN_SET = new Set(Object.keys(borderWidths));
export function isBorderWidthToken(value) {
    return BORDER_WIDTH_TOKEN_SET.has(value);
}
export const BORDER_WIDTH_TOKEN_KEYS = Object.freeze(Object.keys(borderWidths).sort());
//# sourceMappingURL=border-widths.js.map